// React
import React from 'react';
import classNames from 'classnames';
// External libs
import { get } from 'lodash';
// Interfaces
import { Props } from './interfaces';
// Components
import CustomClickableBox from '../custom-clickable-box';
// Styles
import useStyles from './styles';
import StringUtils from '../../../../utils/StringUtils';

const CustomClickableBoxList: React.FC<Props> = ({
  classes,
  options,
  children,
  label,
}) => {
  const componentClasses = useStyles();

  return (
    <div
      className={classNames(
        get(componentClasses, 'root', null),
        get(classes, 'root', null),
      )}
    >
      {!StringUtils.isNullOrEmpty(label) && (
        <div
          className={classNames(
            get(componentClasses, 'label', null),
            get(classes, 'label', null),
          )}
        >
          {label}
        </div>
      )}
      {!!children && (
        <div
          className={classNames(
            get(componentClasses, 'children', null),
            get(classes, 'children', null),
          )}
        >
          {children}
        </div>
      )}
      {options.length > 0 && (
        <div
          className={classNames(
            get(componentClasses, 'options', null),
            get(classes, 'options', null),
          )}
        >
          {options.map((option, index) => (
            <CustomClickableBox
              classes={{
                title: componentClasses.title,
              }}
              description={option.description}
              title={option.title}
              key={index}
              onClick={option.onClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};
CustomClickableBoxList.defaultProps = {
  classes: {},
};
export default CustomClickableBoxList;
